import styled from "styled-components";

export const LighterText = styled.p`
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  color: #63a5c0;
`;
